import cls from './BankAmount.module.css';


interface Props {
  titleBold?: string;
  title: string;
  balanceTitle?: string;
}

export const BankAmount = ({ titleBold, title, balanceTitle }: Props) => {
  return (
    <div className={cls.box}>
      <div className={cls.title}>
        {titleBold && <span className={cls.titleBold}>{titleBold}</span>}
        {title}
      </div>
      <div className={cls.balance}>{balanceTitle}</div>
    </div>
  );
};
